import { render } from "./AnnotationPopup.vue?vue&type=template&id=60c53a7e&scoped=true"
import script from "./AnnotationPopup.vue?vue&type=script&lang=js"
export * from "./AnnotationPopup.vue?vue&type=script&lang=js"

import "../../assets/scss/new_annotation.scss?vue&type=style&index=0&id=60c53a7e&scoped=true&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60c53a7e"]])

export default __exports__